// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__3jpFK","left":"StickyBox_left__FdUKF","right":"StickyBox_right__1ZxuH"};